import { createSelector } from '@reduxjs/toolkit';
import { getDictionaryGroups, getGroups } from '../../groups/selectors';
import { RootState } from '../../store.model';
import RightsUserUtil from '../../../util/rights/RightsUserUtil';
import { getFeatureToggle } from '../../../featureToggle';

export const getRightsList = (state: RootState) => state.rights.items;

export const getRightUserUtilSelector = createSelector(
  [getRightsList, getDictionaryGroups, getFeatureToggle],
  (rightsLust, dictionaryGroups, featureToggle) =>
    new RightsUserUtil(rightsLust, dictionaryGroups, featureToggle)
);
